import { API_URL, downloadFile, openFileInNewTab } from "../api_helper";

const downloadPrescriptionQFGold = async () => {
  const url = "downloads/prescription-tb-gold-quantiferon";
  const response = await downloadFile({
    url: url,
  });
  return response;
};

const downloadPrescriptionChestXray = async () => {
  const url = "downloads/prescription-chest-xray";
  const response = await downloadFile({
    url: url,
  });
  return response;
};

const downloadConsentForm = async () => {
  const url = "downloads/download-consent-form";
  const response = await downloadFile({
    url: url,
  });
  return response;
};

const downloadConsentFormByChatId = async (chatId) => {
  await openFileInNewTab({
    url: `downloads/download-consent-form?chatId=${chatId}`,
  });
};

const downloadMedicalFormByChatId = async (chatId, formType) => {
  await openFileInNewTab({
    url: `downloads/download-medical-form?chatId=${chatId}&formType=${formType}`,
  });
};

const downloadReportByChatId = async (chatId, formType) => {
  await openFileInNewTab({
    url: `downloads/download-report?chatId=${chatId}`,
  });
};

const downloadDocumentByTypeAndChatId = async (chatId, docType) => {
  await openFileInNewTab({
    url: `downloads/download-user-document?chatId=${chatId}&docType=${docType}`,
  });
};

export {
  downloadConsentForm,
  downloadPrescriptionQFGold,
  downloadPrescriptionChestXray,
  downloadConsentFormByChatId,
  downloadMedicalFormByChatId,
  downloadReportByChatId,
  downloadDocumentByTypeAndChatId
};
